// Components
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

// Styles
import { SxProps, Theme, useTheme } from "@mui/material/styles";

type DashboardModalType = {
  headerContent: JSX.Element;
  modalBodySx?: SxProps<Theme>;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const DashboardModal = ({
  headerContent,
  modalBodySx = {},
  isOpen,
  onClose,
  children,
}: DashboardModalType) => {
  const theme = useTheme();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style: {
          boxShadow: "none",
        },
        sx: {
          ...(theme.palette.mode === "dark" && {
            backgroundColor: "#5C6076",
            backgroundImage: "none",
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          backgroundColor:
            theme.palette.mode === "dark" ? "#202338" : "#5B6D7A30",
          borderBottom:
            theme.palette.mode === "dark"
              ? "1px solid #5B6D7A"
              : "1px solid #5B6D7A50",
          padding: "12px 16px",
        }}
      >
        {headerContent}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: 0,
          ...modalBodySx,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DashboardModal;
